import { configConstants as doms } from "../../../constants/configs";

const initialState = { loading: true, list: [], doms: [], domaine: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case doms.GET_DOMAINES:
      var array = [];
      var domns = [];
      var mens = [];
      var spec = [];
      payload.forEach((v) => {
        var dm = {
          id: v.id,
          domaine: v.domaine,
        };
        if (v.mentions.length > 0) {
          v.mentions.forEach((m) => {
            var mnt = {
              id: v.id,
              mention: m.mention,
              domaine: v.domaine,
            };
            if (m.specialites.length > 0) {
              m.specialites.forEach((s) => {
                var sp = {
                  id: v.id,
                  mention: m.mention,
                  specialite: s.specialite,
                  sigle: s.sigle,
                  domaine: v.domaine,
                };
                spec.push(sp);
              });
            } else {
              mens.push(mnt);
            }
          });
        } else {
          domns.push(dm);
        }
      });
      if (spec.length > 0) {
        spec = spec.concat(domns);
        spec = spec.concat(mens);
        array = spec;
      } else if (mens.length > 0) {
        mens = mens.concat(domns);
        array = mens;
      } else {
        array = domns;
      }
      return {
        ...state,
        loading: false,
        list: array,
      };
    case doms.GET_ALL_DOMAINES:
      var array = [];
      payload.forEach((v) => {
        array.push({
          id: v.id,
          nom: v.domaine,
        });
      });
      return {
        ...state,
        loading: false,
        doms: array
      }
    case doms.GET_DOMAINE:
      return {
        ...state,
        loading: false,
        domaine: payload,
      };
    default:
      return state;
  }
}
